import main from '@/translations/en/pages/main';
import privacy from '@/translations/en/pages/privacy';
import agreement from '@/translations/en/pages/agreement';
import error from '@/translations/en/pages/error';
import disclosure from '@/translations/en/pages/disclosure';
import prices from '@/translations/en/pages/prices';
import personal from '@/translations/en/pages/personal';
import contact from '@/translations/en/pages/contact';
import team from '@/translations/en/pages/team';
import header from '@/translations/en/components/header';
import footer from '@/translations/en/components/footer';
import service from '@/translations/en/pages/service';
import global from '@/translations/en/global';

const translation = {
  translation: {
    global,
    pages: {
      main,
      privacy,
      agreement,
      error,
      disclosure,
      prices,
      team,
      personal,
      service,
      contact,
    },
    components: {
      header,
      footer,
    },
  },
};

export default translation;
